import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLinkDetail, PaymentLinkStatus } from '@types'

import { paymentLinkDetailBaseMock } from './payment-link-detail-base'

export const paymentLinkDetailRejectedMock = new MockFactory<PaymentLinkDetail>(
  {
    ...paymentLinkDetailBaseMock.build(),
    status: PaymentLinkStatus.Rejected,
  }
)
